import { Dialog, Transition } from '@headlessui/react';
import { IconAlertTriangle } from '@tabler/icons-react';
import { Fragment, useState } from 'react';
import { getAuthorizationHeader, http } from '../../config/http';
import { toast } from 'react-toastify';

export default function ModalHapusPengeluaran({ isOpenModalLogout, idHapus, closeModaLogout, getPengeluaranHariIni }) {
    const [loading, setLoading] = useState(false)
    async function hapusPengeluaran() {
        setLoading(true)
        try {
            const response = await http.delete(`/cashflow/${idHapus}`, {
                headers: { Authorization: getAuthorizationHeader() },
            });
            toast.success('Data berhasil dihapus', { autoClose: 600, })
            closeModaLogout();
            getPengeluaranHariIni();
            setLoading(false)
            return response.data
        } catch (error) {
            console.log(error)
        }
        setLoading(false)
    }
    return (
        <>
            <Transition appear show={isOpenModalLogout} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={closeModaLogout}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex items-center justify-center p-4 min-h-[440px]">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-sm transform overflow-hidden rounded-lg bg-white dark:bg-slate-900 p-6 text-left align-middle shadow-xl transition-all border dark:border-slate-800">
                                    <div className="flex flex-col items-center text-center">
                                        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 mb-4">
                                            <IconAlertTriangle className="w-8 h-8" />
                                        </div>
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg font-bold leading-6 text-slate-900 dark:text-slate-100 mb-2"
                                        >
                                            Hapus Pengeluaran
                                        </Dialog.Title>
                                        <p className="text-sm text-slate-500 dark:text-slate-400 mb-6">
                                            Apakah Anda yakin ingin menghapus data pengeluaran ini? Tindakan ini tidak dapat dibatalkan.
                                        </p>

                                        <div className="flex w-full gap-3">
                                            <button
                                                type="button"
                                                onClick={closeModaLogout}
                                                className="flex-1 inline-flex justify-center items-center px-4 py-2.5 text-sm font-semibold rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors"
                                            >
                                                Batal
                                            </button>
                                            <button
                                                type="button"
                                                disabled={loading}
                                                onClick={hapusPengeluaran}
                                                className={`flex-1 inline-flex justify-center items-center px-4 py-2.5 text-sm font-semibold rounded-md text-white bg-gradient-to-r from-red-600 to-red-700 hover:from-red-500 hover:to-red-600 shadow-sm transition-all disabled:from-slate-300 disabled:to-slate-300 disabled:text-slate-500 disabled:cursor-not-allowed ${loading ? 'cursor-wait' : ''}`}
                                            >
                                                {loading ? 'Proses...' : 'Hapus'}
                                            </button>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
}
